import React from "react";

export default function FeatureElement({
  selected,
  question,
  answer,
  onClick,
}) {
  return (
    <div
      className={`featureelement ${selected ? "featurelementselected " : ""}`}
      onClick={onClick}
    >
      <div className="featureheaderrow">
        <div className="featureline">
          <h4>{question}</h4>
        </div>
      </div>
      <p>{answer}</p>
    </div>
  );
}
